export default "__VITE_ASSET__4be34cef__"